export default {"src":"/_next/static/media/work.fff1cf1b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};